import { Component, OnInit } from '@angular/core';

declare interface TableData {
    headerRow: string[];
    dataRows: string[][];
}

@Component({
  selector: 'app-tables',
  templateUrl: './tables.component.html',
  styleUrls: ['./tables.component.css']
})
export class TablesComponent implements OnInit {
   public tableData1: TableData;

  ngOnInit() {
      this.tableData1 = {
          headerRow: [ '#', 'Name', 'Email Address', 'Phone Number', 'Actions'],
          dataRows: [
              ['1', 'Andrew Mike', 'andrew@gmail.com', '072712899',''],
              ['2', 'Kevin Micha', 'micha@gmail.com', '072712899',''],
              ['3', 'Henry Onyango', 'henry@gmail.com', '072712899','']
          ]
     };
 }

}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/tables/tables.component.ts